import React, { useState, useEffect } from "react"; // 📌 useEffect 추가
import Login from "./components/Login";
import Main from "./Main"; 
import universityLogo from './images/sejong-logo.jpg'; 
import "./styles/App.css";

function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [user, setUser] = useState(null);

  // 📌 [추가] 새로고침 시 브라우저 저장소(sessionStorage)에서 로그인 정보 복구
  useEffect(() => {
    const token = sessionStorage.getItem("token");
    const userName = sessionStorage.getItem("userName");
    const userId = sessionStorage.getItem("userId");
    const grantFg = sessionStorage.getItem("grantFg");

    // 토큰이 존재한다면 로그인된 상태로 간주하고 State 복구
    if (token && userId) {
      setIsLoggedIn(true);
      setUser({
        login_id: userId,
        name: userName,
        grant_fg: grantFg
      });
    }
  }, []); // 빈 배열([])을 넣어 앱이 처음 렌더링될 때 딱 한 번만 실행됨

  const handleLogin = (userData) => {
    setIsLoggedIn(true);
    setUser(userData);
  };

  // 📌 [수정] 로그아웃 시 State뿐만 아니라 저장소의 데이터도 지워줘야 함
  const handleLogout = () => {
    sessionStorage.clear(); // 또는 removeItem으로 각각 삭제
    setIsLoggedIn(false);
    setUser(null);
  };

  return (
    <div className={isLoggedIn ? "logged-in" : "not-logged-in"}>
      {!isLoggedIn ? (
        <>
          <div className="logo-container">
            <img src={universityLogo} alt="Sejong University Logo" className="university-logo" />
          </div>
          <Login onLogin={handleLogin} />
        </>
      ) : (
        <Main user={user} onLogout={handleLogout} />
      )}
    </div>
  );
}

export default App;
